import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=bc24e348&scoped=true&"
import script from "./stepper.vue?vue&type=script&lang=js&"
export * from "./stepper.vue?vue&type=script&lang=js&"
import style0 from "./stepper.vue?vue&type=style&index=0&id=bc24e348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc24e348",
  null
  
)

export default component.exports